import SkillsMobile from "./SkillsMobile";

export default SkillsMobile;
export { SkillsMobile };
